var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _vm.hasOauthResponse
        ? _c("oauth-pkce-endpoint", {
            on: { "credentials-changed": _vm.handleCredentialsChanged }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDebugInfo
        ? _c(
            "div",
            [
              _vm.showDebugInfo && _vm.credentialInfo
                ? _c(
                    "v-card",
                    [
                      _c("v-card-title", [_vm._v("Credential Info")]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("div", { attrs: { label: "Expires On" } }, [
                            _vm._v(_vm._s(_vm.expiresOn))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { label: "Seconds Until Expiry" } },
                            [
                              _vm._v(
                                _vm._s(_vm.secondsUntilExpiry) +
                                  ", " +
                                  _vm._s(_vm.expiryTimeLeftPercentage)
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.credentialInfo, function(value, key) {
                            return _c(
                              "div",
                              { key: key, attrs: { label: key } },
                              [_vm._v(_vm._s(value))]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showDebugInfo && !_vm.credentialInfo
                ? _c(
                    "v-card",
                    [
                      _c("v-card-title", [_vm._v("Login Info")]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c("div", { attrs: { label: "code_verifier" } }, [
                          _vm._v(_vm._s(_vm.code_verifier))
                        ]),
                        _vm._v(" "),
                        _c("div", { attrs: { label: "code_challenge" } }, [
                          _vm._v(_vm._s(_vm.code_challenge))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { label: "code_challenge (encoded)" } },
                          [
                            _vm._v(
                              _vm._s(_vm.simpleUrlEncode(_vm.code_challenge))
                            )
                          ]
                        ),
                        _vm._v("\n\n                loginUrl"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "a",
                          { attrs: { href: _vm.loginUrl, target: "_blank" } },
                          [_vm._v(_vm._s(_vm.loginUrl))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-toolbar",
                        [
                          _c("v-btn", { on: { click: _vm.beginLogin } }, [
                            _vm._v("Begin Login")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowContent ? _c("div", [_vm._t("default")], 2) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58044018", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58044018","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/oauth-wrapper-pkce.vue
// module id = null
// module chunks = 